<template>

  <div class="container flex flex-col justify-center items-center p-12 gap-16 w-full">
    <div class="flex gap-8 flex-wrap">
      <div class="section p-8 flex flex-col gap-4">
        <h1 class="text-2xl">Privacy Policy for <i>Δίπλωμα Αυτοκινήτου Σήματα ΚΟΚ</i></h1>
        <div class="policy-row mt-1 mb-1">
          <h5>Data Collection and Usage</h5>
          <p><b>No User Data Collection:</b> <i>Δίπλωμα Αυτοκινήτου Σήματα ΚΟΚ</i> does not collect, store, or share
            any personal information. No account or registration is required to use the app.</p>
        </div>
        <div class="policy-row mt-1 mb-1">
          <h5>Data Security</h5>
          <p><b>Data Security:</b> Because no user data is collected, none is stored locally on your device or
            transmitted to any external servers, minimizing any risk to your privacy.</p>
        </div>
        <div class="policy-row mt-1 mb-1">
          <h5>Third-Party Services</h5>
          <p><b>No Third-Party Services:</b> <i>Δίπλωμα Αυτοκινήτου Σήματα ΚΟΚ</i> does not integrate with any
            third-party services or SDKs that collect user data.</p>
        </div>
        <div class="policy-row mt-1 mb-1">
          <h5>Children's Privacy</h5>
          <p><b>No Collection from Children:</b> <i>Δίπλωμα Αυτοκινήτου Σήματα ΚΟΚ</i> is intended for general
            audiences and does not knowingly collect personal information from children under the age of 13.</p>
        </div>
        <div class="policy-row mt-1 mb-1">
          <h5>Changes to this Privacy Policy</h5>
          <p><b>Policy Updates:</b> This Privacy Policy may be updated from time to time. Any changes will be
            communicated through app notifications or app updates.</p>
        </div>
        <div class="policy-row mt-1 mb-1">
          <h5>Contact Us</h5>
          <p><b>Contact Information:</b> Questions or concerns about this Privacy Policy or <i>Δίπλωμα Αυτοκινήτου
              Σήματα ΚΟΚ</i> can be sent to <a
              href="mailto:ploumisalexandrosgr@gmail.com">ploumisalexandrosgr@gmail.com</a>.</p>
        </div>
      </div>
      <div class="images-div w-full flex flex-wrap relative">
        <div class="image-item"><img :src="require(`@/assets/images/img_01.jpg`)"></div>
        <div class="image-item"><img :src="require(`@/assets/images/img_02.jpg`)"></div>
        <div class="image-item"><img :src="require(`@/assets/images/img_03.jpg`)"></div>
        <div class="image-item"><img :src="require(`@/assets/images/img_04.jpg`)"></div>
        <div class="image-item"><img :src="require(`@/assets/images/img_06.jpg`)"></div>
        <div class="image-item"><img :src="require(`@/assets/images/img_07.jpg`)"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileApp'
};
</script>

<style scoped>
.images-div {
  gap: 10px;
}

.image-item {
  height: 480px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  border-radius: 20px;
  overflow: hidden;
}

.image-item img {
  height: 100%;
  width: auto;
  object-fit: contain;
  display: block;
}
</style>